"use client"

import { useFormContext } from "react-hook-form"

import { sanitizeFacetValueString } from "@unlikelystudio/react-ecommerce-hooks"

import SquareCta, { type SquareCtaProps } from "~/components/ui/SquareCta"
import { useAlgoliaCustomContext } from "~/providers/AlgoliaCustomContext/index.client"
import { ClientTranslate } from "~/providers/I18nProvider/ClientTranslate"
import { objectKeys } from "~/utils/object-keys"

export function FiltersResetButton({ onClick, ...props }: SquareCtaProps) {
  const form = useFormContext()
  const { facets, page, setPage, setSelectedFilters } = useAlgoliaCustomContext()

  return (
    <SquareCta
      {...props}
      fill
      onClick={(e) => {
        onClick?.(e)

        const emptyValues = objectKeys(facets ?? {})?.reduce((acc, key) => ({ ...acc, [key]: [] }), {})

        // reset form explicitely with current selected values
        form.reset(
          objectKeys(facets ?? {})?.reduce((acc, key) => {
            const values = objectKeys(facets?.[key] ?? {})?.reduce((emptyObject, value) => {
              const sanitizedValue = sanitizeFacetValueString(value)
              return { ...emptyObject, [sanitizedValue]: false }
            }, {})

            return { ...acc, [key]: values }
          }, {})
        )

        // then update filters context
        setSelectedFilters(emptyValues)

        page > 1 && setPage(1)
      }}
    >
      <ClientTranslate tKey="cta_clear_all_filters" />
    </SquareCta>
  )
}
